import { Fade, Zoom } from 'react-reveal';
import styled from 'styled-components';
function BannerText() {
  return (
      <>
      <Fade>

      <Container className='text-center container-fluid'>
          <div className="row">
              <Fade left>

              <div className="col-3 banner-text-shape">
              </div>
              </Fade>
              <Zoom>

              <div className="col-6">

          <h1>Encouraging a culture wheres <span>IDEAS</span> are welcomed rather than <span>FEARED</span></h1>
          {/* <h2 className='bc'>Encouraging a culture wheres <span>IDEAS</span> are welcomed rather than <span>FEARED.</span></h2> */}

              </div>
              </Zoom>
              <Fade right>

              <div className="col-3 banner-text-shape-right">
              </div>
              </Fade>
          </div>
      </Container>
      </Fade>
      </>
          

  )
}

export default BannerText
const Container = styled.div` 
.banner-text-shape{
    clip-path: polygon(0% 0%, 75% 0%, 100% 50%, 75% 100%, 0% 100%);
    background-color:#fa7525 ;
}
.banner-text-shape-right{
    clip-path: polygon(25% 0%, 100% 0%, 100% 100%, 25% 100%, 0% 50%);
    background-color:#fa7525 ;


}

margin-top:10px ;
margin-bottom:6px ;
/* background-image:linear-gradient(to right, #E5E6EF, white) ; */

.banner-text span{
    color:var(--primary-color) ;
}
@media (min-width:800px){
    h1{
        font-size:30px;
        line-height:35px ;
        margin-bottom:50px;
        margin-top:50px ;
    }
}
`